import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuthPage } from './AuthPage/useAuthPage';
import AuthHero from './AuthPage/AuthHero';
import GoogleSignInButton from './AuthPage/GoogleSignInButton';
import LoginForm from './AuthPage/LoginForm';
import SignupForm from './AuthPage/SignupForm';
import GuestForm from './AuthPage/GuestForm';

export default function AuthPage() {
  const {
    loading, guestLoginEnabled, settingsLoaded, activeTab, setActiveTab,
    loginEmail, setLoginEmail, loginPassword, setLoginPassword, rememberEmail, setRememberEmail,
    signupName, setSignupName, signupEmail, setSignupEmail,
    signupCountryCode, setSignupCountryCode, signupPhone, setSignupPhone, signupPassword, setSignupPassword,
    guestName, setGuestName, guestCountryCode, setGuestCountryCode, guestPhone, setGuestPhone,
    guestOTP, setGuestOTP, otpRequested, setOtpRequested,
    handleLogin, handleClearSavedEmail, handleSignup, handleRequestOTP, handleGuestLogin, handleGoogleSignIn,
  } = useAuthPage();

  return (
    <div className="mobile-container min-h-screen flex flex-col">
      <AuthHero />

      {/* Auth Tabs */}
      <div className="flex-1 p-6 bg-background">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className={`grid w-full ${settingsLoaded && guestLoginEnabled ? 'grid-cols-3' : 'grid-cols-2'} mb-6 ring-1 ring-gray-200 shadow-sm`}>
            <TabsTrigger value="login" data-testid="login-tab" className="data-[state=active]:shadow-none">Login</TabsTrigger>
            <TabsTrigger value="signup" data-testid="signup-tab" className="data-[state=active]:shadow-none">Sign Up</TabsTrigger>
            {settingsLoaded && guestLoginEnabled && (
              <TabsTrigger value="guest" data-testid="guest-tab" className="data-[state=active]:shadow-none">Guest</TabsTrigger>
            )}
          </TabsList>

          {/* ── Google Sign-In — always visible above the fold ────────────── */}
          <GoogleSignInButton onClick={handleGoogleSignIn} />

          <LoginForm
            loginEmail={loginEmail} setLoginEmail={setLoginEmail}
            loginPassword={loginPassword} setLoginPassword={setLoginPassword}
            rememberEmail={rememberEmail} setRememberEmail={setRememberEmail}
            onClearSavedEmail={handleClearSavedEmail}
            loading={loading}
            onSubmit={handleLogin}
          />

          <SignupForm
            signupName={signupName} setSignupName={setSignupName}
            signupEmail={signupEmail} setSignupEmail={setSignupEmail}
            signupCountryCode={signupCountryCode} setSignupCountryCode={setSignupCountryCode}
            signupPhone={signupPhone} setSignupPhone={setSignupPhone}
            signupPassword={signupPassword} setSignupPassword={setSignupPassword}
            loading={loading}
            onSubmit={handleSignup}
          />

          {settingsLoaded && guestLoginEnabled && (
            <GuestForm
              guestName={guestName} setGuestName={setGuestName}
              guestCountryCode={guestCountryCode} setGuestCountryCode={setGuestCountryCode}
              guestPhone={guestPhone} setGuestPhone={setGuestPhone}
              guestOTP={guestOTP} setGuestOTP={setGuestOTP}
              otpRequested={otpRequested} setOtpRequested={setOtpRequested}
              loading={loading}
              onRequestOTP={handleRequestOTP}
              onSubmit={handleGuestLogin}
            />
          )}
        </Tabs>
      </div>
    </div>
  );
}
